import React from 'react';
import { Box, Button, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

export default function LabSampleDetail() {
  const navigate = useNavigate();
  const { batchId, sampleId } = useParams();
  const [searchParams] = useSearchParams();

  const decodedSampleId = decodeURIComponent(sampleId || '');
  const value = searchParams.get('value') || 'N/A';
  const releaseStatus = searchParams.get('status') || 'Under Review';
  const reportedResult = searchParams.get('result') || 'Negative';
  const wellNumber = '5F';

  return (
    <Container disableGutters sx={{ mt: 2, mb: 4 }}>
      <Box sx={{ maxWidth: 980, mx: 'auto' }}>
        <Stack spacing={2}>
          <Box>
            <Button variant="text" onClick={() => navigate(`/mock/lab-results-batch/${batchId}`)}>
              Back to Batch
            </Button>
          </Box>

          <Card sx={{ border: '1px solid #d8e2e7', boxShadow: 'none', borderRadius: 3 }}>
            <CardContent sx={{ p: { xs: 2.5, md: 3 } }}>
              <Typography variant="h4" component="h1">
                Sample Details
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                Mock full-page sample detail view.
              </Typography>
            </CardContent>
          </Card>

          <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
            <Card sx={{ border: '1px solid #e5ebef', boxShadow: 'none', borderRadius: 2, flex: 1 }}>
              <CardContent>
                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                  Sample
                </Typography>
                <Typography variant="body2"><strong>Sample ID:</strong> {decodedSampleId}</Typography>
                <Typography variant="body2"><strong>Batch:</strong> {batchId}</Typography>
                <Typography variant="body2"><strong>Well Number:</strong> {wellNumber}</Typography>
                <Typography variant="body2"><strong>Value:</strong> {value}</Typography>
                <Typography variant="body2"><strong>Reported Result:</strong> {reportedResult}</Typography>
                <Typography variant="body2"><strong>Release Status:</strong> {releaseStatus}</Typography>
              </CardContent>
            </Card>

            <Card sx={{ border: '1px solid #e5ebef', boxShadow: 'none', borderRadius: 2, flex: 1 }}>
              <CardContent>
                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                  Notes
                </Typography>
                <Typography variant="body2">
                  Sample metadata and review annotations can be displayed here in the final implementation.
                </Typography>
              </CardContent>
            </Card>
          </Stack>
        </Stack>
      </Box>
    </Container>
  );
}
